import i18next from 'i18next';

import { formattedDateTime } from '../../../../../utils/dateUtils';
import { isDefined } from '../../../../../utils/variables';

/**
 * Returns a string representing the number formatted in Swedish locale, or the default value '-'
 * if undefine.
 * @param value Number to format.
 * @param postfix Postfix if any.
 * @param numFractionDigits Fixed number of digits. Defaults to two.
 */
export const numberOrDefault = (
  value: number | undefined,
  postfix?: string,
  numFractionDigits = 2,
  signDisplay?: Intl.NumberFormatOptions['signDisplay'],
) => {
  if (!isDefined(value)) {
    return '-';
  }

  const formattedNumber = value.toLocaleString(i18next.language, {
    minimumFractionDigits: numFractionDigits,
    maximumFractionDigits: numFractionDigits,
    signDisplay,
  });

  return postfix ? `${formattedNumber} ${postfix}` : formattedNumber;
};

/**
 * Returns the string or the default value '-' if undefined or empty string.
 */
export const stringOrDefault = (value: string | undefined | null) => {
  return isDefined(value) && value.trim().length > 0 ? value : '-';
};

/**
 * Returns the string or the default value '-' if undefined or empty string.
 */
export const stringOrManualDefault = (value: string | undefined | null, defaultString: string) => {
  return isDefined(value) && value.trim().length > 0 ? value : defaultString;
};

/**
 * Returns a string representing the date formatted in Swedish locale, or default value '-' if
 * undefined.
 */
export const dateTimeOrDefault = (value: string | undefined) => {
  return isDefined(value) ? formattedDateTime(value) : '-';
};
